module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_styled_02-b4f6a5ef645d1d7ebe8143aa6f1e50f2.png";